import React from 'react';

export interface TabConfig {
  key: string;
  label: string;
}

interface TabBarProps {
  tabs: TabConfig[];
  active: string;
  onChange: (key: string) => void;
}

/** Underlined tab switcher used to split pages into sub-views (e.g. Invoices vs Debit Notes) */
const TabBar: React.FC<TabBarProps> = ({ tabs, active, onChange }) => (
  <div className="flex border-b border-gray-200">
    {tabs.map((tab) => (
      <button key={tab.key} type="button" onClick={() => onChange(tab.key)}
        className={`px-4 py-2 text-sm font-medium border-b-2 -mb-px transition-colors ${
          active === tab.key
            ? 'border-ocean-600 text-ocean-700'
            : 'border-transparent text-gray-500 hover:text-gray-700'
        }`}>
        {tab.label}
      </button>
    ))}
  </div>
);

export default TabBar;
